<template>
    <div class="login-page">
        <div class="login-box">
            <div class="shop-title">
                <img src="../../assets/login/thumb.png" alt="">
            </div>
            <div class="login-content">
                <div class="element-div">
                    <div class="login-title">
                        {{$t('adminTitle')}}
                    </div>
                    <Form ref="loginForm" :model="loginForm" :rules="ruleCustom" :label-width="0" class="login-formstyle">
                        
                        <FormItem  class="itemss" prop="email">
                            <div class="login-names">
                               <Icon type="ios-person-outline" size='24' />
                            </div>
                            <input type="text" :placeholder="$t('loginPage.userName')" v-model.trim="loginForm.email" @keyup.enter="loginSubmit"/>
                        </FormItem>
                        <FormItem class="itemss" prop="password">
                            <div class="login-names">
                               <Icon type="ios-unlock-outline"  size='24'/>
                            </div>
                            <div style="display:flex;align-items: center;width:100%;position:relative;">
                                <input 
                                    :type="showPassword ? 'text' : 'password'"  
                                    maxlength="20" 
                                    :placeholder="$t('loginPage.password')" 
                                    v-model.trim="loginForm.password" 
                                    @keyup.enter="loginSubmit"
                                    style="width:100%;"
                                />
                                <Icon 
                                    :type="!showPassword ? 'ios-eye-off' : 'ios-eye'" 
                                    size="20" 
                                    @click="togglePasswordVisibility"
                                    style="position:absolute;right:10px;cursor:pointer;color:#515a6e;"
                                />
                            </div>
                             <!-- <input :type="showPassword ? 'text' : 'password'"   maxlength="20" :placeholder="$t('loginPage.password')" v-model.trim="loginForm.password" @keyup.enter="loginSubmit"/> -->
                        </FormItem>
                        <FormItem class="itemss" prop="vercode">
                             <div class="login-names" style="width:88px;height: 38px;line-height: 38px;">
                               <Icon type="ios-create-outline"  size='24'/>
                            </div>
                            <div style="display:flex;align-items: center">
                                 <input type="text" :placeholder="$t('loginPage.VerificationCode')" v-model.trim="loginForm.vercode" @keyup.enter="loginSubmit"/>
                                <img @click="changeCaptcha" :src="captchaurl" class="login-imgs"/>
                            </div>
                        </FormItem>
    
                        <div class=" flexBC">
                             <Checkbox v-model="loginForm.checked">{{$t('loginPage.RememberPassword')}}</Checkbox>
                             <div class="forgetPwd" @click="forgetPwd">{{$t('loginPage.ForgetPassword')}}?</div>
                        </div>
    
    
    
                        <FormItem  class="login-btn">
                            <Button :loading="disabled"  @click="loginSub('loginForm')" class="login-btn-sub">{{$t('loginPage.Signin')}}</Button>
                        </FormItem>
                    </Form>
                </div>
            </div>
            <loding :showLoding='disabled'  background="rgba(0,0,0,.3)"></loding>
        </div>
         
        <setAdminModellBox :setAdminModel.sync="adminBox.setAdminModel" :dataRow="adminBox.dataRow"   :fn="adminBox.callbackAdFn"></setAdminModellBox>
        
        <div class="footerICP">
            <a href="https://beian.miit.gov.cn" target="_blank" style="color:#515a6e ;">苏ICP备19056288号-1</a>
            <div class="flexC">{{ $t("copyright") }}</div>
        </div>
        
    </div>
</template>
<script>
/**
 * 登录
 */
import isValid from '../../common/isValid.js';
import common from '@/common/common.js';
import setAdminModellBox from './component/setAdminModel.vue';  //忘记密码
import Loding from '../common/Loding.vue';
import {mapMutations} from 'vuex'
import CryptoJS from "crypto-js";
    export default {
        data() {
            return {
                captchaurl:'',
                showPassword: false,
                loginForm: {
                    password: '',
                    email: '',
                    vercode: '',
                    checkCodeKey:'',
                    checked:false,
                    remember:'0'
                },
                adminBox:{//忘记密码框组
                    dataRow:{},
                    setAdminModel:false,
                    callbackFn:()=>{}, 
                },
                ruleCustom: {

                    email: [
                        { required: true, message: this.$t('required'), trigger: 'blur' },
                        // { min: 1, max: 30, message: '用户名长度1 - 30', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: this.$t('required'), trigger: 'blur' },
                        // { min: 6, max: 15, message: '密码长度6 - 15', trigger: 'blur' }
                    ],
                    vercode: [
                        { required: true, message: this.$t('required'), trigger: 'blur' }
                    ]
                },
                disabled: false
            }
        },
        components: {
            setAdminModellBox,
            Loding
        },
        methods: {
             ...mapMutations([
                'set_uInfo',
               'setSelectId',
               'setShowChildrenSide',
               'setLocal',
               'setTokenInvalidFlag'
            ]),
            togglePasswordVisibility() { 
                this.showPassword = !this.showPassword;
            },
            forgetPwd(){//忘记密码
                this.adminBox.setAdminModel = true
                this.adminBox.dataRow = this.uInfo
                this.adminBox.callbackAdFn = () => {//回调处理
                    //重新载入
                    this.getData()
                    this.adminBox.setAdminModel = false;
                }

            },
            loginSub(name) {
             
                const self = this;
                this.$refs[name].validate((valid) => {          
                    if (valid) {
                        self.disabled = true
                        if(self.loginForm.checked){
                            self.loginForm.remember = '1'
                        }else{
                            self.loginForm.remember = '0'
                        }

                        isValid.getNewToken(this.config.urlArray.getToken, this.loginForm, 1, ()=>{
                           self.disabled = false;
                           self.changeCaptcha(); //刷新图形验证码
                        },(item)=>{
                             self.set_uInfo(item)
                        
                             let flag = item.roleType==1?true:false
                             self.setShowChildrenSide(flag)

                             self.setSelectId(item.id)
                             self.setTokenInvalidFlag(false)
                             window.localStorage.loginOut = 'false';
                             
                            if (self.loginForm.checked == true) {

                                //传入账号名，密码，和保存天数3个参数
                                self.setCookie(self.loginForm.email, self.loginForm.password, 30);
                            }else {
                            //   console.log("清空Cookie");
                              //清空Cookie
                              self.clearCookie();
                            }
                        });
                    }
                })
            },
            loginSubmit(event) { // enter快捷键
                event = event || window.event;
                if (event.keyCode === 13 && !this.disabled) {
                    this.loginSub('loginForm');
                }
            },
            changeCaptcha (){
                this.getCaptcha();                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       
            },
            getCaptcha () {
                let time = (new Date()).getTime()
                this.loginForm.checkCodeKey = '51437e4a-419d-478c-bd2e-73797fe7f044'
                this.captchaurl = this.config.urlArray.getCaptcha+'?checkCodeKey='+this.loginForm.checkCodeKey+'&time='+time

            },

            //设置cookie
            setCookie(c_name, c_pwd, exdays) {

                let cipherPortId  = CryptoJS.AES.encrypt(c_name+"", 'self.loginForm.name').toString()
                let cipherPsw  = CryptoJS.AES.encrypt(c_pwd+"", 'self.loginForm.password').toString()

                // console.log(cipherPortId+'/'+cipherPsw)//打印一下看看有没有加密成功

                var exdate = new Date(); //获取时间
                exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
                //字符串拼接cookie
                window.document.cookie = "userName" + "=" + cipherPortId + ";path=/;expires=" + exdate.toGMTString();
                window.document.cookie = "userPwd" + "=" + cipherPsw + ";path=/;expires=" + exdate.toGMTString();
            },
            //读取cookie
            getCookie: function() {
                if (document.cookie.length > 0) {
                    var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
                    for (var i = 0; i < arr.length; i++) {
                        var arr2 = arr[i].split('='); //再次切割
                        //判断查找相对应的值
                        if (arr2[0] == 'userName') {
                             let bytes = CryptoJS.AES.decrypt(arr2[1], 'self.loginForm.name')
                             this.loginForm.email = bytes.toString(CryptoJS.enc.Utf8); //保存到保存数据的地方
                             this.loginForm.checked = true
                        } else if (arr2[0] == 'userPwd') {
                            let bytes = CryptoJS.AES.decrypt(arr2[1], 'self.loginForm.password')
                            this.loginForm.password = bytes.toString(CryptoJS.enc.Utf8);
                        }
                    }
                }
            },
            //清除cookie
            clearCookie: function() {
                this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
            }
        },
        mounted:function (){
          this.getCaptcha();
          this.getCookie();

        }
    }
</script>
<style  lang='scss' scoped>
.forgetPwd{
    cursor: pointer;
    color: #029789;
}
#app {
    width: 100%;
    height: 100%;
}
.ident-pos{
    margin-top: 8px;
}
.type-css{
    width: 152px;margin-left:15px;float: right;
}
.login-page {
    width: 100%;
    height: 100vh;
    position: relative;
}
.login-content {
    height: 100%;
    background: #fff;
    flex: 1;
    box-sizing: border-box;
    display: flex;
    align-content: center;
    justify-content: center;
    .ivu-input{
        border: none !important;
    }
}
.login-box{
    position: absolute;
    width: 1000px;
    height: 550px;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    border-radius: 10px;
    overflow: hidden;
}
.shop-title{
    flex: 1;
    background: #CDFFF5;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    img{
        width: 390px;
    }
}
.login-title {
    width: 345px;
    line-height: 50px;
    text-align: center;
    font-size: 24px;
    margin: 0 auto;
    color: #02ACA2;
    margin-top: 20%;
    margin-bottom: 30px;
}

.login-btn {
    width: 100%;
    height: 40px;
    margin-top: 10px;
}
.login-btn-sub {
    width: 100%;
    background: #02ACA2;
    color: #fff;
    height: 40px;
    margin-top: 20px;
}
.login-names {
    width: 110px;
    padding-left: 10px;
}
.login-imgs {
    margin-left: 10px;
    height: 38px;
}
.login-support {
    width: 100%;
    text-align: center;
    font-size: 12px;
    margin-top: 30px;
}
.ivu-form-item {
    margin-bottom: 30px !important;
}
/*  -------------------------------------------------  */
.forget-pwd>span {
    cursor: pointer;
}
.login-page{
    background:#F5F5F7 url("../../assets/login/bc_img.png")  !important;
    background-size:100% 100%;
}
.shop-title1{
    font-size:29px;
    color:black;
    margin-bottom:35px;
    
}
.shop-title2{
    width:368px;
    line-height:30px;
    font-size:16px;
    color:#A7A7A7;
}
.itemss{
    width:100%;
    display:flex;
    border:1px solid #DDDDDD;
    flex-wrap:nowrap;
    height: 40px;
    align-items: center;
    input{
        border: none;
        width: 100%;
        outline: none;
    }
}
.ivu-form-item-error .ivu-input{
    height: 38px;
    border:none !important;
}
// >>>.ivu-input{
//     height: 38px !important;
//     border:none !important;
// }


</style>
<style>
.login-page .ivu-form-item-content{
    margin-left: 0 !important;
}
.login-page .ivu-form-item-content{
    display: flex;
    width:100%;
    justify-items:center;
}
.forget-pwd {
    text-align: right;
    padding: 15px 0;
    font-size: 14px;
    /* cursor: pointer; */
    color: #666666;
    width:345px;
    height:50px;
}
/* ----------------------- */

</style>


<style lang="less" scoped>
// .login-title{
//     background-color: @itemBgc;
// }
.footerICP{
    position: absolute;
    left: 50%;
    bottom: 10px;
    transform: translateX(-50%);
    font-size: 16px;
    font-weight: bold;
    text-align: center;
}
.beian /deep/ .ivu-btn-text:hover{
    background-color: transparent !important;
}
</style>